import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    backgroundColor: colors.backgroundL1Inverse,
    gap: theme.spacing[5],
  },
  categorySection: {
    gap: theme.spacing[4],
  },
  categoryHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    columnGap: theme.spacing[4],
  },
  categoryHeaderContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[1],
  },
  categoryTitle: {
    flex: 1,
  },
  categoryDescription: {
    marginTop: theme.spacing[3],
  },
  trackersContainer: {
    gap: theme.spacing[4],
    marginTop: theme.spacing[2],
  },
  trackerCard: {
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: 'rgba(58, 58, 60, 1)',
    borderRadius: theme.borderRadius.m,
    padding: theme.spacing[5],
    gap: theme.spacing[3],
  },
  trackerHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[3],
  },
  trackerLogo: {
    width: 32,
    height: 32,
    borderRadius: theme.borderRadius.xs,
    backgroundColor: colors.backgroundPrimary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  trackerInfo: {
    flex: 1,
    gap: theme.spacing[1],
  },
  trackerName: {
    fontSize: 12,
    lineHeight: 15,
  },
  trackerCount: {
    fontSize: 9,
    lineHeight: 13,
    letterSpacing: 0.07,
    textTransform: 'uppercase',
    opacity: 0.6,
  },
  trackerDescription: {
    fontSize: 12,
    lineHeight: 16,
  },
  actionsContainer: {
    flexDirection: 'row',
    gap: theme.spacing[2],
    marginTop: theme.spacing[2],
  },
  actionButton: {
    flex: 1,
    height: 42,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: colors.borderPrimary,
    borderRadius: theme.borderRadius.s,
  },
  detailsContainer: {
    gap: theme.spacing[5],
  },
  detailsHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[2],
  },
  backButton: {
    padding: theme.spacing[2],
  },
  backArrow: {
    transform: [{ rotate: '90deg' }],
  },
  detailsTitle: {
    flex: 1,
  },
  cookieItemsContainer: {
    flex: 1,
    gap: theme.spacing[3],
  },
  cookieItemCard: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderColor: 'rgba(58, 58, 60, 1)',
    paddingVertical: theme.spacing[4],
    paddingHorizontal: theme.spacing[2],
    gap: theme.spacing[3],
  },
  cookieItemName: {
    fontSize: 14,
    lineHeight: 18,
    fontWeight: '600',
  },
  cookieItemDescription: {
    fontSize: 12,
    lineHeight: 16,
  },
  cookieItemMeta: {
    flexDirection: 'row',
    gap: theme.spacing[4],
    marginTop: theme.spacing[2],
  },
  cookieItemMetaColumn: {
    gap: theme.spacing[1],
  },
  arrowExpanded: {
    transform: [{ rotate: '0deg' }],
  },
  arrowCollapsed: {
    transform: [{ rotate: '270deg' }],
  },
  categoryHeaderButton: {
    padding: theme.spacing[2],
    marginLeft: -theme.spacing[2],
  },
}));
